module.exports = __webpack_public_path__ + "img/bio-purple-1.39bd802.jpg";